import { useState } from 'react'

import { Button } from 'antd'

const ArrowIcon = ({ isExpanded }: { isExpanded: boolean }) => (
  <svg
    fill="none"
    height="16"
    style={{
      transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
      transition: 'transform 0.2s ease-in-out',
    }}
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M8 9L4 5L3 6L8 11L13 6L12 5L8 9Z"
      fill="#333333"
      fillRule="evenodd"
    />
  </svg>
)

export function ListButtonExpand({
  label,
  onClick,
}: Readonly<{
  label: string
  onClick?: () => void
}>) {
  const [isExpanded, setIsExpanded] = useState(false)

  const handleClick = () => {
    setIsExpanded(prev => !prev)
    onClick?.()
  }

  return (
    <Button
      icon={<ArrowIcon isExpanded={isExpanded} />}
      iconPosition="end"
      size="small"
      styles={{
        icon: {
          height: '16px',
        },
      }}
      type="text"
      onClick={handleClick}
    >
      {label}
    </Button>
  )
}

export default ListButtonExpand
